/**
 * @generated SignedSource<<37a4a97c0b1158c9f1f3d0de6caa68a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TurnListQuery$variables = {
  masterdataId: string;
};
export type TurnListQuery$data = {
  readonly salesAssociates: {
    readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_salesAssociatesConnection">;
  };
  readonly salesAssociateTrackingMovementFlows: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_movement">;
      };
    }>;
  };
  readonly salesAssociateTrackingServiceFlow: {
    readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_salesAssociateTrackingFlow">;
  } | null;
};
export type TurnListQuery = {
  variables: TurnListQuery$variables;
  response: TurnListQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "masterdataId"
  }
],
v1 = {
  "fields": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "eq",
          "variableName": "masterdataId"
        }
      ],
      "kind": "ObjectValue",
      "name": "masterdataId"
    }
  ],
  "kind": "ObjectValue",
  "name": "store"
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "active",
        "value": {
          "eq": true
        }
      },
      (v1/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v3 = [
  {
    "fields": [
      (v1/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positioningRule",
  "storageKey": null
},
v7 = [
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesAssociateTrackingMovementStep",
  "kind": "LinkedField",
  "name": "stepToClose",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v7/*: any*/),
      "type": "AdminUiIcon",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TurnListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SalesAssociateConnection",
        "kind": "LinkedField",
        "name": "salesAssociates",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TurnListProvider_salesAssociatesConnection"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SalesAssociateTrackingMovementStepConnection",
        "kind": "LinkedField",
        "name": "salesAssociateTrackingMovementFlows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociateTrackingMovementStepEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesAssociateTrackingMovementStep",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TurnListProvider_movement"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SalesAssociateTrackingFlow",
        "kind": "LinkedField",
        "name": "salesAssociateTrackingServiceFlow",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TurnListProvider_salesAssociateTrackingFlow"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TurnListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SalesAssociateConnection",
        "kind": "LinkedField",
        "name": "salesAssociates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesAssociate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Avatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "queueAppPassword",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SalesAssociateTrackingMovementStepConnection",
        "kind": "LinkedField",
        "name": "salesAssociateTrackingMovementFlows",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociateTrackingMovementStepEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesAssociateTrackingMovementStep",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SalesAssociateTrackingMovementStep",
                    "kind": "LinkedField",
                    "name": "nextSteps",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SalesAssociateTrackingMovementStep",
                        "kind": "LinkedField",
                        "name": "stepToClose",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SalesAssociateTrackingMovementStep",
                        "kind": "LinkedField",
                        "name": "nextSteps",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SalesAssociateTrackingFlow",
        "kind": "LinkedField",
        "name": "salesAssociateTrackingServiceFlow",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "LostReason",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "type": "Occurrence",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  (v12/*: any*/)
                ],
                "type": "OccurrenceReference",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesAssociateTrackingServiceFlowTree",
            "kind": "LinkedField",
            "name": "trees",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paths",
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e7f6d7b3b77d578b3d59a3f9f28f7c8",
    "id": null,
    "metadata": {},
    "name": "TurnListQuery",
    "operationKind": "query",
    "text": "query TurnListQuery(\n  $masterdataId: String!\n) {\n  salesAssociates(where: {store: {masterdataId: {eq: $masterdataId}}, active: {eq: true}}, first: 50) {\n    ...TurnListProvider_salesAssociatesConnection\n  }\n  salesAssociateTrackingMovementFlows(where: {store: {masterdataId: {eq: $masterdataId}}}) {\n    edges {\n      node {\n        ...TurnListProvider_movement\n        id\n      }\n    }\n  }\n  salesAssociateTrackingServiceFlow(where: {store: {masterdataId: {eq: $masterdataId}}}) {\n    ...TurnListProvider_salesAssociateTrackingFlow\n  }\n}\n\nfragment InStoreListItem_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment MovementsModal_movementStep on SalesAssociateTrackingMovementStep {\n  id\n  description\n}\n\nfragment MovementsModal_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment MultipleAssistancesContentTemplate_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment OccurrencesContentTemplate_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment OccurrencesModal_salesAssociate on SalesAssociate {\n  ...OccurrencesContentTemplate_salesAssociate\n  ...MultipleAssistancesContentTemplate_salesAssociate\n  ...SalesAssociatesContentTemplate_salesAssociate\n}\n\nfragment OutOfStoreListItem_moviment on SalesAssociateTrackingMovementStep {\n  name\n  icon {\n    __typename\n    ... on AdminUiIcon {\n      id\n    }\n  }\n}\n\nfragment OutOfStoreListItem_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment SalesAssociatePasswordModal_salesAssociate on SalesAssociate {\n  id\n  name\n  avatar {\n    url\n  }\n  queueAppPassword\n}\n\nfragment SalesAssociatesContentTemplateItem_salesAssociate on SalesAssociate {\n  id\n  name\n  avatar {\n    url\n  }\n}\n\nfragment SalesAssociatesContentTemplate_salesAssociate on SalesAssociate {\n  name\n  avatar {\n    url\n  }\n}\n\nfragment SalesAssociatesModal_salesAssociate on SalesAssociate {\n  id\n  ...SalesAssociatePasswordModal_salesAssociate\n}\n\nfragment SalesAssociatesModal_salesAssociatesConnection on SalesAssociateConnection {\n  edges {\n    node {\n      id\n      name\n      avatar {\n        url\n      }\n      ...SalesAssociatesModal_salesAssociate\n    }\n  }\n}\n\nfragment TurnListProvider_movement on SalesAssociateTrackingMovementStep {\n  id\n  name\n  positioningRule\n  ...utils_unfinishedMovement\n  ...OutOfStoreListItem_moviment\n  ...MovementsModal_movementStep\n  stepToClose {\n    id\n  }\n  nextSteps {\n    id\n    positioningRule\n    ...utils_unfinishedMovement\n    ...OutOfStoreListItem_moviment\n    ...MovementsModal_movementStep\n    nextSteps {\n      id\n      positioningRule\n      ...utils_unfinishedMovement\n      ...OutOfStoreListItem_moviment\n      ...MovementsModal_movementStep\n      stepToClose {\n        id\n      }\n    }\n    stepToClose {\n      id\n      positioningRule\n      ...OutOfStoreListItem_moviment\n      ...MovementsModal_movementStep\n    }\n  }\n}\n\nfragment TurnListProvider_salesAssociateTrackingFlow on SalesAssociateTrackingFlow {\n  ...utils_buildOccurrencesTrees\n}\n\nfragment TurnListProvider_salesAssociatesConnection on SalesAssociateConnection {\n  edges {\n    node {\n      id\n      ...utils_salesAssociate\n    }\n  }\n  ...SalesAssociatesModal_salesAssociatesConnection\n}\n\nfragment utils_buildOccurrencesTrees on SalesAssociateTrackingFlow {\n  items {\n    __typename\n    ... on LostReason {\n      id\n      name\n    }\n    ... on Occurrence {\n      color\n      id\n      name\n      positioningRule\n    }\n    ... on OccurrenceReference {\n      id\n      type\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  trees {\n    id\n    paths\n    type\n  }\n}\n\nfragment utils_salesAssociate on SalesAssociate {\n  id\n  ...OutOfStoreListItem_salesAssociate\n  ...InStoreListItem_salesAssociate\n  ...MovementsModal_salesAssociate\n  ...OccurrencesModal_salesAssociate\n  ...SalesAssociatesContentTemplateItem_salesAssociate\n}\n\nfragment utils_unfinishedMovement on SalesAssociateTrackingMovementStep {\n  id\n  stepToClose {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd99a70aeb27ee35d1263b493f760fdc";

export default node;
